import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  Table,
  Button,
  Spinner
} from 'reactstrap';
import { Link } from 'react-router-dom';
import getLangData from '../../../utils/getLangData';
import langText from '../../../utils/langText';

const PublicInquriyComp = props => {
  const {showDate = true} = props
  const {
    actions,
    title,
    proposal_no,
    date
  } = getLangData().components.public_inquiry;
  return (
    <Card>
      <CardHeader>
        <div className='d-flex justify-content-between align-items-center'>
          <CardTitle className='mb-0 text-bold'>{props.cardTitle}</CardTitle>
          {props.children}
        </div>
      </CardHeader>
      <Table responsive className='text-center'>
        <thead>
          <tr>
            <th>{title}</th>
            <th>{proposal_no}</th>
            {showDate && <th>{date}</th>}
            <th>{}</th>
          </tr>
        </thead>

        <tbody>
          {props.isLoading && (
            <div className='d-flex justify-content-center w-100'>
              <Spinner />
            </div>
          )}
          {props.items?.map((item, i) => {
            const date = new Date(item.createdAt);
            return (
              <tr key={i}>
                <td>{`${item.title}`}</td>
                <td>{item.proposals.length}</td>
                {showDate && (
                  <td>
                    {date.getDate() +
                      ' - ' +
                      date.getMonth() +
                      ' - ' +
                      date.getFullYear()}
                  </td>
                )}

                <td className='danger'>
                  <Link to={`${props.edit}/${item._id}`}>
                    <Button color='link'>
                      {getLangData().components.actions.view}
                    </Button>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default PublicInquriyComp;
